module.exports = __webpack_public_path__ + "img/join-select.f8a39f72.png";